/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 14c5.306 0 8 2.917 8 7v1h-2v-1c0-2.86-1.709-5-6-5s-6 2.14-6 5v1H2v-1c0-4.083 2.694-7 8-7zm11.293-5.707 1.414 1.414L18 14.414l-2.707-2.707 1.414-1.414L18 11.586zM10 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgContactCheck as ContactCheck };
